<!-- eslint-disable vue/no-mutating-props -->
<template>
	<div class="slide-editor no-print">
		<div class="section-tit mt-4">
			추가 슬라이드 / 빈 페이지
			<span class="slide-count">{{ slides.length }}/20</span>
		</div>
		<p class="slide-caution">출력물 <b>맨 뒤(부록)</b>에 추가됩니다. 사진은 페이지에 비율 유지로 배치되고 캡션을 달 수 있어요(평면도·호재 사진 등).</p>
		<div class="slide-actions">
			<label class="slide-add" :class="{ disabled: full || uploading }">
				<input type="file" accept="image/png,image/jpeg" @change="onFile" :disabled="full || uploading" hidden />
				{{ uploading ? '업로드 중…' : '＋ 사진 추가' }}
			</label>
			<button type="button" class="slide-add" :disabled="full" @click="$emit('add-blank')">＋ 빈 페이지</button>
		</div>
		<p v-if="full" class="slide-caution warn">최대 20개까지 추가할 수 있습니다.</p>

		<div class="slide-list">
			<div class="slide-item" v-for="(s, i) in slides" :key="s.id">
				<div class="slide-no">{{ i + 1 }}</div>
				<div class="slide-thumb">
					<img v-if="s.type === 'photo' && thumbUrl(s)" :src="thumbUrl(s)" alt="" />
					<span v-else class="slide-blank-tag">빈</span>
				</div>
				<div class="slide-body">
					<input v-if="s.type === 'photo'" type="text" class="form-control form-control-sm"
						v-model="s.caption" @change="emitChange" placeholder="캡션(선택)" maxlength="80" />
					<span v-else class="slide-blank-label">빈 페이지</span>
				</div>
				<div class="slide-ops">
					<button type="button" @click="move(i, -1)" :disabled="i === 0" title="위로">▲</button>
					<button type="button" @click="move(i, 1)" :disabled="i === slides.length - 1" title="아래로">▼</button>
					<button type="button" class="slide-del" @click="remove(i)" title="삭제">✕</button>
				</div>
			</div>
			<p v-if="!slides.length" class="slide-empty">추가된 페이지가 없습니다. '＋ 사진 추가' 또는 '＋ 빈 페이지'로 추가하세요.</p>
		</div>
	</div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
// 부모(믹스인/연쇄덱)가 소유한 reactive slides 배열을 in-place 편집(splice/캡션 v-model).
// InvestmentSidebarEditor 와 동일 관례 — 같은 배열 참조라 양쪽 반응성 유지, 추가는 부모가 push.
import { slideImagePath } from '@/utils/printSlides.mjs';

export default {
	name: 'SlideEditor',
	emits: ['change', 'add-photo', 'add-blank'],
	props: {
		slides: { type: Array, default: () => [] },
		uploading: { type: Boolean, default: false },
	},
	computed: {
		full() { return this.slides.length >= 20; },
	},
	methods: {
		emitChange() { this.$emit('change'); },
		onFile(e) {
			const f = e.target.files && e.target.files[0];
			e.target.value = '';   // 같은 파일 재선택 허용
			if (f) this.$emit('add-photo', f);
		},
		remove(i) { this.slides.splice(i, 1); this.$emit('change'); },
		move(i, dir) {
			const j = i + dir;
			if (j < 0 || j >= this.slides.length) return;
			const [s] = this.slides.splice(i, 1);
			this.slides.splice(j, 0, s);
			this.$emit('change');
		},
		thumbUrl(s) {
			if (s.type !== 'photo' || !s.imgId) return '';
			return process.env.VUE_APP_HOST_BACK + slideImagePath(s.imgId, 160, 70);
		},
	},
};
</script>

<style scoped>
.slide-editor { padding: 0 4px; }
.slide-count { float: right; font-size: 11px; color: #888; font-weight: 400; }
.slide-caution { color: #b45309; font-size: 10px; margin-top: 5px; line-height: 1.35; }
.slide-caution.warn { color: #c0392b; }
.slide-actions { display: flex; gap: 8px; margin-top: 8px; }
.slide-add { flex: 1 1 auto; text-align: center; font-size: 11px; padding: 5px 8px; border: 1px solid #d7b9b9; background: #fff; color: #7a1818; border-radius: 6px; cursor: pointer; font-weight: 600; margin: 0; }
.slide-add:hover { background: #faf3f3; }
.slide-add:disabled, .slide-add.disabled { opacity: 0.5; cursor: not-allowed; }
.slide-list { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; }
.slide-item { display: flex; align-items: center; gap: 6px; border: 1px solid #eee; border-radius: 6px; padding: 4px 6px; }
.slide-no { flex: 0 0 16px; font-size: 11px; color: #aaa; text-align: center; }
.slide-thumb { flex: 0 0 40px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: #f3f3f3; border-radius: 4px; overflow: hidden; }
.slide-thumb img { width: 100%; height: 100%; object-fit: cover; }
.slide-blank-tag { font-size: 10px; color: #999; }
.slide-body { flex: 1 1 auto; min-width: 0; }
.slide-body .form-control-sm { font-size: 11px; }
.slide-blank-label { font-size: 11px; color: #888; }
.slide-ops { flex: 0 0 auto; display: flex; align-items: center; gap: 2px; }
.slide-ops button { border: none; background: none; cursor: pointer; font-size: 11px; color: #777; padding: 2px 3px; line-height: 1; }
.slide-ops button:disabled { opacity: 0.3; cursor: default; }
.slide-ops .slide-del { color: #c0392b; font-size: 13px; }
.slide-ops .slide-del:hover { color: #7a1818; }
.slide-empty { font-size: 10px; color: #aaa; margin: 4px 0 0; }
</style>
